import { render } from "./SpecsSection.vue?vue&type=template&id=17f3f972&scoped=true"
import script from "./SpecsSection.vue?vue&type=script&lang=js"
export * from "./SpecsSection.vue?vue&type=script&lang=js"

import "./SpecsSection.vue?vue&type=style&index=0&id=17f3f972&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f3f972"]])

export default __exports__